import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "formatError"
})
export class FormatErrorPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {

    if (typeof value === "string") {
      const formattedValue = value.replace(/_/g, " ");
      if (formattedValue === formattedValue.toLocaleLowerCase()) {
        return formattedValue.charAt(0).toUpperCase() + formattedValue.slice(1);
      }
      return formattedValue;
    }
    return value;
  }

}
